/* eslint-disable */
// jshint ignore: start
var SVGIcons = {
"dot.svg": {
 draw: function(ctx){
ctx.save();
ctx.strokeStyle="rgba(0,0,0,0)";
ctx.miterLimit=4;
ctx.font="normal normal 400 normal 15px / 21.4286px ''";
ctx.font="   15px ";
ctx.save();
ctx.font="   15px ";
ctx.save();
ctx.fillStyle="rgba(0,0,0,0)";
ctx.font="   15px ";
ctx.beginPath();
ctx.moveTo(-1,-1);
ctx.lineTo(11,-1);
ctx.bezierCurveTo(11,-1,11,-1,11,-1);
ctx.lineTo(11,11);
ctx.bezierCurveTo(11,11,11,11,11,11);
ctx.lineTo(-1,11);
ctx.bezierCurveTo(-1,11,-1,11,-1,11);
ctx.lineTo(-1,-1);
ctx.bezierCurveTo(-1,-1,-1,-1,-1,-1);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();
ctx.save();
ctx.font="   15px ";
ctx.save();
ctx.fillStyle="#fff";
ctx.fillStyle="rgba(255, 255, 255, NaN)";
ctx.strokeStyle="#000";
ctx.strokeStyle="rgba(0, 0, 0, NaN)";
ctx.lineWidth=0.001;
ctx.font="   15px ";
ctx.globalAlpha=0.5;
ctx.beginPath();
ctx.moveTo(9.880946,5);
ctx.bezierCurveTo(9.880946,7.6956720405476124,7.6956720405476124,9.880946,5,9.880946);
ctx.bezierCurveTo(2.3043279594523876,9.880946,0.11905400000000022,7.6956720405476124,0.11905400000000022,5);
ctx.bezierCurveTo(0.11905400000000022,2.3043279594523876,2.3043279594523876,0.11905400000000022,5,0.11905400000000022);
ctx.bezierCurveTo(7.6956720405476124,0.11905400000000022,9.880946,2.3043279594523876,9.880946,5);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.save();
ctx.fillStyle="#fff";
ctx.fillStyle="rgba(255, 255, 255, NaN)";
ctx.strokeStyle="#000";
ctx.strokeStyle="rgba(0, 0, 0, NaN)";
ctx.lineWidth=0.001;
ctx.font="   15px ";
ctx.beginPath();
ctx.moveTo(6.642858,5);
ctx.bezierCurveTo(6.642858,5.907325419537518,5.907325419537518,6.642858,5,6.642858);
ctx.bezierCurveTo(4.092674580462482,6.642858,3.357142,5.907325419537518,3.357142,5);
ctx.bezierCurveTo(3.357142,4.092674580462482,4.092674580462482,3.357142,5,3.357142);
ctx.bezierCurveTo(5.907325419537518,3.357142,6.642858,4.092674580462482,6.642858,5);
ctx.closePath();
ctx.fill();
ctx.stroke();
ctx.restore();
ctx.restore();
ctx.restore();
}

}}
for(var name in SVGIcons){
            Q.registerImage(name, SVGIcons[name]);
        }
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/svg-icons-etc.js